import { render, staticRenderFns } from "./range-slider.vue?vue&type=template&id=20d9891a&"
import script from "./range-slider.vue?vue&type=script&lang=js&"
export * from "./range-slider.vue?vue&type=script&lang=js&"
import style0 from "./range-slider.vue?vue&type=style&index=0&id=20d9891a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports